import "@babel/polyfill";
import "mutationobserver-shim";
import Vue from "vue";
import VueRouter from "vue-router";
import axios from "axios";
import router from "./router";
import App from "./App.vue";
import "./assets/css/animations.scss";
import "./plugins/bootstrap-vue";

import store from "./store";

axios.defaults.baseURL = "https://auth.tactint.com";
axios.defaults.headers.post["Content-Type"] = "application/json; charset=utf-8";
axios.defaults.withCredentials = true;
Vue.prototype.axios = axios;

Vue.config.productionTip = false;

Vue.use(VueRouter);

store.dispatch("verifyAccount").then(() => {
  new Vue({
    render: h => h(App),
    router,
    store
  }).$mount("#app");
});
